<template>
  <div class="container-xl">
    <div class="card col-lg-12">
      <div class="card-header justify-content-between">
        <div class="card-title">Invoice Detail</div>
      </div>
      <div class="table-responsive">
        <el-skeleton :loading="is_loading" :rows="6" animated />
        <table v-if="!is_loading" class="table card-table text-nowrap table-vcenter">
          <thead>
            <tr>
              <th width="20%">Invoice Number</th>
              <th width="20%">Disbursement Date</th>
              <th width="25%">Requestor Name</th>
              <th>Amount</th>
              <th>Admin Fee</th>
              <th>Total</th>
              <th>Invoice Status</th>
              <th>Paid Date</th>
              <!-- <th>#</th> -->
            </tr>
          </thead>
          <tbody v-loading="is_loading">
            <tr v-for="(item, i) in list" :key="i">
              <td>{{ item.invoice_number }}</td>
              <td>{{ item.disburse_at_str }}</td>
              <td>{{ item.requestor_name }}</td>
              <td>{{ item.principal_amount_str }}</td>
              <td>{{ item.interest_amount }}</td>
              <td>{{ item.request_amount_str }}</td>
              <td>
                <span class="tag" :class="item.status_color">{{ item.status_str }}</span>
              </td>
              <td>{{ item.paid_at_str }}</td>
              <!-- <td>
                <el-button type="success" @click="handlerUpdateStatus(item)" :disabled="item.status == 'paid'" size="mini">Mark as paid</el-button>
              </td> -->
            </tr>
          </tbody>
        </table>
        <el-empty description="No data found" v-if="!total_rows && !is_loading" :image="emptyStateImage"></el-empty>
      </div>
      <pagination
        :page="page"
        :per_page="per_page"
        :list="list"
        :total_rows="total_rows"
        @pageChange="pageChangeHandler"
        />
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import {
  INVOICE_DETAIL_AWA, ROLLBACK_APPROVAL, INVOICE_PARTIAL_UPDATE_STATUS,
} from '@/store/modules/awa';
import emptyStateImage from '@/assets/images/undraw/empty-approval-history.svg';
import Pagination from '../../components/Pagination.vue';
import popupErrorMessages from '../../../library/popup-error-messages';

export default {
  components: { Pagination },
  name: 'DetailAwaCompany',
  data() {
    return {
      emptyStateImage,
      is_loading: false,
      total_rows: 0,
      page: 1,
      per_page: 20,
      list: [],
      show: {
        modal_ewa: false,
        update_invoice: false,
      },
      loading: {
        modal_ewa: false,
      },
      selected_invoice_item: {},
      status_filter: '',
      disbursement_status_filter: '',
      search: {
        search_keyword: '',
        search_by: 'full_name',
        date: [
          moment().subtract(1, 'month').format('YYYY-MM-DD'),
          moment().format('YYYY-MM-DD'),
        ],
        action: '',
      },
      search_options: [
        { value: 'full_name', text: 'Requestor Name' },
        { value: 'email', text: 'Requestor Email' },
        { value: 'phone_number', text: 'Requestor Phone Number' },
      ],
      datePickerOptions: {
        disabledDate: (date) => moment(date).isAfter(moment(), 'days'),
      },
    };
  },
  metaInfo: {
    title: 'Advanced Wage Access',
  },
  computed: {
    showingFrom() {
      return this.total_rows ? ((this.page - 1) * this.per_page) + 1 : 0;
    },
    showingUntil() {
      if (this.total_rows) {
        if (this.list.length < this.per_page) {
          return this.total_rows;
        }
        return this.page * this.per_page;
      }
      return 0;
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      this.is_loading = true;
      this.$parent.showLoader();
      if (this.$route.params.status) {
        delete this.search.date;
      }
      await this.$store.dispatch(INVOICE_DETAIL_AWA, {
        id: this.$route.params.id,
        invoice_id: this.$route.params.invoice_id,
        query: {
          page: this.page,
          per_page: this.per_page,
        },
      }).then((data) => {
        if (this.search.action === 'download') {
          const anchor = document.createElement('a');
          anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(data)}`;
          anchor.target = '_blank';
          anchor.download = `Earned_Wage_Report_${moment(this.search.date[0]).format('YYYY-MM-DD')}-${moment(this.search.date[1]).format('YYYY-MM-DD')}`;
          anchor.click();
        }
      });
      this.$parent.hideLoader();
      if (this.search.action !== 'download') {
        const { rows, count } = this.$store.getters.detail_invoice_awa;
        this.list = rows;
        this.total_rows = count;
      }
      this.is_loading = false;
    },
    pageChangeHandler(page) {
      this.page = page;
      this.getList();
    },
    searchHandler() {
      this.search.action = '';
      this.pageChangeHandler(1);
    },
    downloadHandler() {
      this.search.action = 'download';
      this.pageChangeHandler(1);
    },
    handlerBtnReject(item) {
      const obj = {
        owned_by: item.owned_by,
      };
      this.$confirm('You reject this request. You can not undo this action. Continue?', 'Confirmation', {
        type: 'info',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            await this.$store.dispatch(ROLLBACK_APPROVAL, {
              id: this.$route.params.id,
              current_state: this.$route.params.status,
              data: obj,
            }).then(() => {
              this.$message({
                title: 'Success',
                type: 'success',
                message: 'Rejection success',
              });
              this.getList();
            }).catch((err) => {
              if (err.response?.data) popupErrorMessages(err.response.data);
            });
            instance.confirmButtonLoading = false;
          }
          done();
        },
      }).catch(() => {});
    },
    handlerUpdateStatus(item) {
      this.$confirm('Mark this item as paid?', 'Confirmation', {
        type: 'info',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            await this.$store.dispatch(INVOICE_PARTIAL_UPDATE_STATUS, {
              company_id: this.$route.params.id,
              data: {
                ewa_invoice_id: item.ewa_invoice_id,
                ewa_request_id: item.ewa_request_id,
              },
            }).then(() => {
              this.$message({
                title: 'Success',
                type: 'success',
                message: 'Successfully update data',
              });
              this.getList();
            }).catch((err) => {
              if (err.response?.data) popupErrorMessages(err.response.data);
            });
            instance.confirmButtonLoading = false;
          }
          done();
        },
      }).catch(() => {});
    },
  },
};
</script>
<style>
.el-range-separator {
  width: 10% !important;
}
</style>